var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "226.83 411.15 501.31 803.15 623.31 803.15 348.82 411.15 226.83 411.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "348.72 628.87 226.69 803.15 348.77 803.15 409.76 716.05 348.72 628.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "651.23 196.85 440.28 498.12 501.32 585.29 773.31 196.85 651.23 196.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "673.31 383.25 673.31 803.15 773.31 803.15 773.31 240.44 673.31 383.25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXai);
export default __webpack_public_path__ + "static/media/xai.9efb9e3843db6a0b294ffbea37cdc369.svg";
export { ForwardRef as ReactComponent };